// @flow

export const createPromise = (): Promise<*> => {
    let _resolve, _reject;

    const promise = new Promise<*>((resolve, reject) => {
        _resolve = resolve;
        _reject = reject;
    });

    // $FlowIgnoreMe WHY: Because this method added to resolve promise externally
    promise.resolve = _resolve;
    // $FlowIgnoreMe WHY: Because this method added to resolve promise externally
    promise.reject = _reject;

    return promise;
};
